import { Package } from "lucide-react";
import { compactINR } from "@/lib/api";

const METRICS = [
  { key: "activation_rate", label: "Activation rate", fmt: (v) => `${v}%`, hint: "made at least 1 sale" },
  { key: "monthly_producer_rate", label: "Monthly producer rate", fmt: (v) => `${v}%`, hint: "1+ new customer this month" },
  { key: "avg_new_customers_this_month", label: "Avg new customers (MTD)", fmt: (v) => v },
  { key: "avg_new_customers_lifetime", label: "Avg new customers (lifetime)", fmt: (v) => v },
  { key: "avg_revenue_lifetime", label: "Avg revenue / affiliate (lifetime)", fmt: (v) => compactINR(v) },
];

const Lift = ({ a, b }) => {
  if (!b) return <span className="text-[10px] text-muted-foreground">—</span>;
  const pct = Math.round(((a - b) / b) * 100);
  const cls = pct > 0 ? "text-emerald-600 bg-emerald-500/10" : pct < 0 ? "text-rose-600 bg-rose-500/10" : "text-muted-foreground bg-secondary";
  return <span className={`text-[10px] font-semibold rounded-full px-2 py-0.5 ${cls}`}>{pct > 0 ? "+" : ""}{pct}%</span>;
};

export const StarterKitCompare = ({ data, compact = false, testId = "starter-kit-compare" }) => {
  if (!data) return null;
  const { buyers: b, non_buyers: n } = data;
  return (
    <div data-testid={testId} className="rounded-2xl border border-border/60 bg-card p-6">
      <div className="flex items-center gap-2 flex-wrap">
        <Package className="h-5 w-5 text-primary" />
        <h3 className="text-lg font-semibold tracking-tight">Starter Kit Buyers vs Non-Buyers</h3>
        <span className="ml-auto text-xs text-muted-foreground">
          <b data-testid={`${testId}-buyers-count`} className="text-foreground">{b.count}</b> bought · <b data-testid={`${testId}-nonbuyers-count`} className="text-foreground">{n.count}</b> didn't · Paused excluded
        </span>
      </div>
      {b.count < 10 && (
        <div data-testid={`${testId}-small-sample`} className="mt-2 text-[11px] text-amber-600">Only {b.count} buyer{b.count === 1 ? "" : "s"} recorded so far. The comparison becomes meaningful as ASMs mark more starter kit purchases.</div>
      )}
      <div className={`mt-5 grid gap-3 ${compact ? "grid-cols-2 md:grid-cols-5" : "grid-cols-1 md:grid-cols-5"}`}>
        {METRICS.map((m) => (
          <div key={m.key} data-testid={`${testId}-${m.key}`} className="rounded-xl border border-border/60 bg-secondary/20 p-4">
            <div className="flex items-start justify-between gap-2">
              <div className="text-[10px] uppercase tracking-widest text-muted-foreground">{m.label}</div>
              <Lift a={b[m.key]} b={n[m.key]} />
            </div>
            <div className="mt-3 flex items-baseline justify-between">
              <span className="text-[10px] uppercase tracking-widest text-emerald-600">Bought</span>
              <span className="text-xl font-semibold">{m.fmt(b[m.key])}</span>
            </div>
            <div className="mt-1 flex items-baseline justify-between">
              <span className="text-[10px] uppercase tracking-widest text-muted-foreground">Didn't</span>
              <span className="text-base text-muted-foreground">{m.fmt(n[m.key])}</span>
            </div>
            {m.hint && !compact && <div className="mt-2 text-[10px] text-muted-foreground">{m.hint}</div>}
          </div>
        ))}
      </div>
    </div>
  );
};
